import { render, staticRenderFns } from "./ImageEditIndex.vue?vue&type=template&id=5122ddfc&scoped=true"
import script from "./ImageEditIndex.vue?vue&type=script&lang=js"
export * from "./ImageEditIndex.vue?vue&type=script&lang=js"
import style0 from "./ImageEditIndex.vue?vue&type=style&index=0&id=5122ddfc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5122ddfc",
  null
  
)

export default component.exports